interface WishlistModal {
  visible: boolean;
  title: string;
  text: string;
  init(): void;
}

export default {
  name: "wishlistModal",
  component(): WishlistModal {
    return {
      visible: false,
      title: "",
      text: "",

      init() {
        document.addEventListener("ooo-wishlist:product-added", (event) => {
          this.visible = true;
          this.title = "Produit ajouté à votre liste de souhaits";
          this.text =
            "Vous pouvez maintenant ajouter ce produit à votre panier ou continuer vos achats.";
          setTimeout(() => {
            this.visible = false;
          }, 3000);
        });

        document.addEventListener("ooo-wishlist:product-removed", (event) => {
          this.visible = true;
          this.title = "Produit retiré de votre liste de souhaits";
          this.text =
            "Vous pouvez maintenant ajouter ce produit à votre panier ou continuer vos achats.";
          setTimeout(() => {
            this.visible = false;
          }, 3000);
        });
      },
    };
  },
};
